import axios from '../../app/axios';
import Vue from 'vue';


const state = {
  accounts:[],
  phrases:[],
  hashtags:[],
  mentions:[]

}

const actions = {

  /**
   * 
   * Fetch accounts watched list
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   paginateAccountsList({commit,state},payload) {

     return new Promise( (resolve,reject) => {
       	return axios.get(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_ACCOUNT_API}`,{ params:payload }).then( response => {

         	commit("setAccountsList", response.data.data);
         	return resolve(response.data)

       	}).catch( error => console.log(error))
     }).catch( error => console.log(error))

   },

  /**
   * 
   * create new account
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   createAccount({commit,state},payload) {

     return new Promise( (resolve,reject) => {
       	return axios.post(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_ACCOUNT_API}`,payload).then( response => {

         	commit("pushAccount", response.data.data);
         	return resolve(response.data)

       	}).catch( error => reject(error))
     })

   },

  /**
   * 
   * Remove Account
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   removeAccount({commit,state},payload) {

     return new Promise( (resolve,reject) => {

     	if( !payload.hasOwnProperty('id') ){
     		return reject("Payload requires [id]");
     	}

       	return axios.delete(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_ACCOUNT_API}/${payload.id}`).then( response => {

         	commit("removeAccount", payload);
         	return resolve(response.data)

       	}).catch( error => console.log(error))
     }).catch( error => console.log(error))

   },

  /**
   * 
   * Fetch hashtags watched list
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   paginateHashtagsList({commit,state},payload) {

     return new Promise( (resolve,reject) => {
       	return axios.get(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_HASHTAG_API}`,{ params:payload }).then( response => {

         	commit("setHashtagsList", response.data.data);
         	resolve(response.data)

       	}).catch( error => console.log(error))
     }).catch( error => console.log(error))

   },

  /**
   * 
   * create new hashtag
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   createHashtag({commit,state},payload) {

     return new Promise( (resolve,reject) => {
       	return axios.post(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_HASHTAG_API}`,payload).then( response => {

         	commit("pushHashtag", response.data.data);
         	return resolve(response.data)

       	}).catch( error => reject(error))
     })

   },

  /**
   * 
   * Remove hashtag
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   removeHashtag({commit,state},payload) {

     return new Promise( (resolve,reject) => {
       	
       	if( !payload.hasOwnProperty('id') ){
     		return reject("Payload requires [id]");
     	}

       	return axios.delete(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_HASHTAG_API}/${payload.id}`).then( response => {

         	commit("removeHashtag", payload);
         	return resolve(response.data)

       	}).catch( error => console.log(error))
     }).catch( error => console.log(error))

   },

  /**
   * 
   * Fetch hashtags watched list
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   paginatePhrasesList({commit,state},payload) {

     return new Promise( (resolve,reject) => {
       	return axios.get(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_PHRASE_API}`,{ params:payload }).then( response => {

         	commit("setPhrasesList", response.data.data);
         	resolve(response.data)

       	}).catch( error => console.log(error))
     }).catch( error => console.log(error))

   },

  /**
   * 
   * create new Phrase
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   createPhrase({commit,state},payload) {

     return new Promise( (resolve,reject) => {
       	return axios.post(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_PHRASE_API}`,payload).then( response => {

         	commit("pushPhrase", response.data.data);
         	return resolve(response.data)

         }).catch( error => reject(error))
     })

   },

  /**
   * 
   * Remove Phrase
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   removePhrase({commit,state},payload) {

     return new Promise( (resolve,reject) => {
       	
       	if( !payload.hasOwnProperty('id') ){
     		return reject("Payload requires [id]");
     	}

       	return axios.delete(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_PHRASE_API}/${payload.id}`).then( response => {

         	commit("removePhrase", payload);
         	return resolve(response.data)

       	}).catch( error => console.log(error))
     }).catch( error => console.log(error))

   },
  
  /**
   * 
   * Fetch hashtags watched list
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   paginateMentionsList({commit,state},payload) {

     return new Promise( (resolve,reject) => {
       	return axios.get(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_MENTION_API}`,{ params:payload }).then( response => {

         	commit("setMentionsList", response.data.data);
         	resolve(response.data)

       	}).catch( error => console.log(error))
     }).catch( error => console.log(error))

   },

  /**
   * 
   * create new Mention
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   createMention({commit,state},payload) {

     return new Promise( (resolve,reject) => {
       	return axios.post(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_MENTION_API}`,payload).then( response => {

         	commit("pushMention", response.data.data);
         	return resolve(response.data)

       	}).catch( error => reject(error))
     })

   },

  /**
   * 
   * Remove Phrase
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return Promise
   */
   removeMention({commit,state},payload) {

     return new Promise( (resolve,reject) => {
       	
       	if( !payload.hasOwnProperty('id') ){
     		return reject("Payload requires [id]");
     	}

       	return axios.delete(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_MENTION_API}/${payload.id}`).then( response => {

         	commit("removeMention", payload);
         	return resolve(response.data)

       	}).catch( error => console.log(error))
     }).catch( error => console.log(error))

   },

 }

 const mutations = {

  /**
   * Set Accounts
   * @param {Object} state 
   * @param {Object} payload 
   */
   setAccountsList(state, payload = []) {

     return state.accounts = payload

   },

  /**
   * puch single Account
   * @param {Object} state 
   * @param {Object} payload 
   */
   pushAccount(state, payload = []) {

     return state.accounts.push(payload)

   },

  /**
   * Remove Account
   * @param {Object} state 
   * @param {Object} payload 
   */
   removeAccount(state, payload = {}) {

     return state.accounts = state.accounts.filter( account => account.id != payload.id );

   },

  /**
   * Set Hashtags
   * @param {Object} state 
   * @param {Object} payload 
   */
   setHashtagsList(state, payload = []) {

     return state.hashtags = payload

   },

  /**
   * puch single hashtag
   * @param {Object} state 
   * @param {Object} payload 
   */
   pushHashtag(state, payload = []) {

     return state.hashtags.push(payload)

   },

  /**
   * Remove Hashtag
   * @param {Object} state 
   * @param {Object} payload 
   */
   removeHashtag(state, payload = {}) {

     return state.hashtags = state.hashtags.filter( hashtag => hashtag.id != payload.id );

   },

  /**
   * Set Pharases
   * @param {Object} state 
   * @param {Object} payload 
   */
   setPhrasesList(state, payload = []) {

     return state.phrases = payload    

   },

  /**
   * puch single Phrase
   * @param {Object} state 
   * @param {Object} payload 
   */
   pushPhrase(state, payload = []) {

     return state.phrases.push(payload)

   },

  /**
   * Remove phrase
   * @param {Object} state 
   * @param {Object} payload 
   */
   removePhrase(state, payload = {}) {

     return state.phrases = state.phrases.filter( phrase => phrase.id != payload.id );

   },

  /**
   * Set Mentions
   * @param {Object} state 
   * @param {Object} payload 
   */
   setMentionsList(state, payload = []) {

     return state.mentions = payload  

   },

  /**
   * puch single mention
   * @param {Object} state 
   * @param {Object} payload 
   */
   pushMention(state, payload = []) {

     return state.mentions.push(payload)

   },

  /**
   * Remove Mention
   * @param {Object} state 
   * @param {Object} payload 
   */
   removeMention(state, payload = {}) {

     return state.mentions = state.mentions.filter( mention => mention.id != payload.id );

   },

 }

 const getters = {


 }

 export default {
   state,
   mutations,
   actions,
   getters
 }